<template>
  <div class="wrapper-tabulator">
    <div ref="table" class="table"></div>
  </div>
</template>

<script>
import Tabulator from "tabulator-tables";
export default {
  name: "tabulator",
  props: {
    data: {
      type: Array,
      required: false,
      default: [],
    },
    columns: {
      type: Array,
      required: false,
      default: [],
    },
    type: {
      type: String,
      required: true,
      default: "",
    },
    local: {
      type: String | Object,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      tabulator: null,
      tableData: [],
    };
  },
  watch: {
    data: {
      handler(newData) {
        this.tabulator.replaceData(newData);
      },
      deep: true,
    },
  },
  mounted() {
    let generate = new Promise((resolve, reject) => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: this.data, //link data to table
        height: 0,
        layout: "fitColumns",
        columns: this.columns,
        downloadConfig: {
          columnHeaders: true, //do not include column headers in downloaded table
          columnGroups: true, //do not include column groups in column headers for downloaded table
          rowGroups: true, //do not include row groups in downloaded table
          columnCalcs: false, //do not include column calcs in downloaded table
          dataTree: false, //do not include data tree in downloaded table
        },
      });
      resolve();
    });
    generate.then((data) => {
      if (this.type === "xlsx") {
        this.downloadXLSX();
      } else if (this.type === "csv") {
        this.downloadCSV();
      } else if (this.type === "html") {
        this.downloadHTML();
      }
    });
  },
  methods: {
    downloadXLSX() {
      this.tabulator.download("xlsx", `Relatório-${this.local}.xlsx`, {
        sheetName: `Relatório-Estacao`,
      });
      this.$emit("clean");
    },
    downloadCSV() {
      this.tabulator.download("csv", `Relatório-${this.local}.csv`, {
        bom: true,
      });
      this.$emit("clean");
    },
    downloadPDF() {
      this.tabulator.download("pdf", `Relatório-${this.local}.pdf`, {
        documentProcessing: function (workbook) {
          workbook.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            CreatedDate: new Date(2017, 12, 19),
          };

          this.$emit("clean");
          return workbook;
        },
      });
    },
  },
};
</script>

<style scoped>
.wrapper-tabulator >>> .tabulator {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  border: none;
}

.wrapper-tabulator >>> .tabulator .tabulator-header {
  font-weight: normal;
  border-bottom: 1px solid;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.54);
}

.wrapper-tabulator >>> .tabulator .tabulator-header .tabulator-col {
  height: 38px;
  background-color: #f7f7f7;
  padding: 0 6px;
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}

.wrapper-tabulator >>> .tabulator-row {
  border-bottom: 1px solid;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  min-height: 48px;
  vertical-align: middle;
}

.wrapper-tabulator >>> .tabulator-row .tabulator-cell {
  padding: 16px 7px;
  vertical-align: middle;
}

.wrapper-tabulator >>> .tabulator-row .tabulator-cell:first-of-type,
.wrapper-tabulator >>> .tabulator .tabulator-header .tabulator-col:first-of-type {
  padding-left: 24px;
}

.wrapper-tabulator >>> .tabulator-row.tabulator-row-even {
  background-color: #fcfcfc;
}
</style>
